import { Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { mediaUrl } from '@/hooks/useMediaUrl';

export function LeftSidebar() {
  const { user } = useAuthStore();
  const location = useLocation();

  if (!user) return null;

  const navItems = [
    { to: '/feed', label: 'News Feed', icon: '📰' },
    { to: '/messages', label: 'Messages', icon: '💬' },
    { to: '/events', label: 'Events', icon: '📅' },
    { to: '/friends', label: 'Friends', icon: '👥' },
    { to: '/groups', label: 'Groups', icon: '🏘️' },
    { to: '/notes', label: 'Notes', icon: '📝' },
    { to: '/directory', label: 'Neighborhood', icon: '🏪' },
  ];

  return (
    <div className="hidden lg:block w-44 shrink-0 space-y-3">
      {/* Profile card */}
      <Link to={`/profile/${user.username}`} className="card block hover:shadow-md transition-shadow">
        <div className="p-3 flex items-center gap-2">
          <img
            src={mediaUrl(user.avatar_key)}
            alt=""
            className="w-10 h-10 rounded object-cover"
          />
          <div className="min-w-0">
            <div className="font-bold text-xs text-sand-800 truncate">{user.display_name}</div>
            <div className="text-[10px] text-sand-500 truncate">@{user.username}</div>
          </div>
        </div>
      </Link>

      {/* Navigation */}
      <div className="card">
        <nav className="py-1">
          {navItems.map(({ to, label, icon }) => {
            const active = location.pathname.startsWith(to);
            return (
              <Link
                key={to}
                to={to}
                className={`flex items-center gap-2 px-3 py-1.5 text-xs font-semibold transition-colors ${
                  active
                    ? 'bg-vibe-50 text-vibe-600 border-l-2 border-vibe-500'
                    : 'text-sand-600 hover:bg-sand-50 hover:text-sand-800'
                }`}
              >
                <span className="text-sm">{icon}</span>
                {label}
              </Link>
            );
          })}
        </nav>
      </div>

      {/* Footer */}
      <div className="text-[10px] text-sand-500 leading-relaxed px-1">
        About · Privacy · Terms · Help<br />
        <span className="text-vibe-500 font-semibold">vibration</span> © 2025
      </div>
    </div>
  );
}
